<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc" xmlns:epub="http://www.idpf.org/2007/ops">
<ol>
<li><span href="#/About#toc_marker-1" title="Link target outside of Sample">About the Author</span></li>
<li><span href="#/Title_Page#toc_marker-2" title="Link target outside of Sample">Title Page</span></li>
<li><span href="#/Copyright#toc_marker-3" title="Link target outside of Sample">Copyright Information</span></li>
<li><a href="#/Contents#toc_marker-4">Contents</a></li>
<li><a href="#/Faries#toc_marker-5">Introduction</a></li>
<li><a href="#/Faries1#toc_marker-6">One</a></li>
<li><a href="#/Faries2#toc_marker-7">Two</a></li>
<li><a href="#/Faries3#toc_marker-8">Three</a></li>
<li><a href="#/Faries4#toc_marker-9">Four</a></li>
<li><a href="#/Faries5#toc_marker-10">Five</a></li>
<li><a href="#/Faries6#toc_marker-11">Six</a></li>
<li><a href="#/Faries7#toc_marker-12">Conclusion</a></li>
<li><a href="#/Faries8#toc_marker-13">Glossary</a></li>
<li><a href="#/Faries9#toc_marker-14">Bibliography</a></li>
</ol>
</nav>
<div>
<p class="x1toc" id="toc_marker-4">contents<a id="x-contents-"></a></p><a id="x-contents-">
</a><p class="toc-1"><a id="x-contents-"></a><a href="#/Faries#Anchor">Introduction</a></p>
<p class="toc-1"><a href="#/Faries1#Anchor-2">One</a>: Getting Started with Faeries</p>
<p class="toc-1"><a href="#/Faries2#Anchor-3">Two</a>: Communicating with Elementals to Understand and Improve Your Life</p>
<p class="toc-1"><a href="#/Faries3#Anchor-4">Three</a>: Sylphs–Elementals of Air</p>
<p class="toc-1"><a href="#/Faries4#Anchor-5">Four</a>: Salamanders–Elementals of Fire</p>
<p class="toc-1"><a href="#/Faries5#Anchor-6">Five</a>: Undines–Elementals of Water</p>
<p class="toc-1"><a href="#/Faries6#Anchor-7">Six</a>: Gnomes–Elementals of Earth</p>
<p class="toc-1"><a href="#/Faries7#Anchor-8">Conclusion</a></p>
<p class="toc-1"><a href="#/Faries8#Anchor-9">Glossary</a></p>
<p class="toc-1"><a href="#/Faries9#Anchor-10">Bibliography</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?1259a81f